import { useQuery } from '@apollo/client/react';
import { STAFF_SUBNETS } from '@staff-app/graphql-client';
import type { Subnet } from '@staff-app/shared-types';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@staff-app/ui';
import { SubnetRow } from '../components/SubnetRow';
import { Network } from 'lucide-react';

export function SubnetsPage() {
  const { data, loading, error } = useQuery<{ staffSubnets: Subnet[] }>(STAFF_SUBNETS, {
    fetchPolicy: 'cache-and-network',
  });
  const subnets = data?.staffSubnets ?? [];

  return (
    <div className="flex flex-col gap-6 p-6" data-testid="subnets-page">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-foreground">
          <Network className="h-6 w-6" />
          {'Network / Subnets'}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {'Source: deploy/config/network.yaml (git). Read-only.'}
        </p>
      </div>

      {error ? (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          {error.message}
        </div>
      ) : loading && !subnets.length ? (
        <div className="text-sm text-muted-foreground">{'Loading subnets…'}</div>
      ) : (
        <div className="rounded-lg border bg-card">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{'Name'}</TableHead>
                <TableHead>{'CIDR / Range'}</TableHead>
                <TableHead>{'Type'}</TableHead>
                <TableHead>{'Provisioner?'}</TableHead>
                <TableHead>{'Usage'}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subnets.map((subnet) => (
                <SubnetRow key={subnet.name} subnet={subnet} />
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
